export const PROJECT_FILES_CONFIG = {
    name            : 'Files',
    menuName        : 'Files',
    icon            : 'i5-file',
    // iconLight       : 'i5-files-light',
    image           : 'files',
    iconSvg         : 'isvg-view-files',
    url             : 'files',
    stringId        : 'files',
    description     : 'Manage project-related files and task attachments.',
    inheritance     : false,
    isSingleton     : true,
}
